import { render, staticRenderFns } from "./MotorcycleStudentLearningTable.vue?vue&type=template&id=0adb5be0&scoped=true&"
import script from "./MotorcycleStudentLearningTable.vue?vue&type=script&lang=js&"
export * from "./MotorcycleStudentLearningTable.vue?vue&type=script&lang=js&"
import style0 from "./MotorcycleStudentLearningTable.vue?vue&type=style&index=0&id=0adb5be0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb5be0",
  null
  
)

export default component.exports